import { Navigate } from "react-router-dom";
import { usePermissions } from "./usePermissions";

// Route guard: blocks the whole page when the user lacks "view" on the module.
export default function RequirePermission({ module, children }) {
  const { can, user } = usePermissions();

  if (!user) return <Navigate to="/" replace />;

  if (!can(module, "view")) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          gap: 12,
          color: "var(--text-muted)",
          textAlign: "center",
          padding: 24,
        }}
      >
        <i
          className="fa-solid fa-lock"
          style={{ fontSize: 44, color: "var(--accent)", opacity: 0.7 }}
        />
        <h2 style={{ margin: 0, color: "var(--text)" }}>لا تملك صلاحية الوصول</h2>
        <p style={{ margin: 0 }}>
          هذه الصفحة غير متاحة لدورك الحالي. تواصل مع المدير لمنحك الصلاحية.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
